import React from 'react';
import { Box } from '@material-ui/core';
import CategoryIcon from '@material-ui/icons/Category';
import { useTranslate } from 'react-admin';
import CollapsePanel from '../components/CollapsePanel';
import InfoItem from './components/InfoItem';
import MetadataAvatarTypePropertiesBatched from '../../avatarAnc/columns/MetadataAvatarTypePropertiesBatched';

interface CharacteristicsPanelProps {
    selected: any;
}

/**
 * Muestra los specs de producto (volumen de fangos, volumen útil, modelo y
 * capacidad) que se ocultan en los cards en móvil. Soporta ambas vistas:
 * - avatares (/p/ancs): los specs se resuelven por `metadataAvatarType`.
 * - boards (/p/ancs_every_2_hours): los specs vienen planos en el record.
 */
const CharacteristicsPanel: React.FC<CharacteristicsPanelProps> = ({ selected }) => {
    const t = useTranslate();

    const metadataId = (() => {
        const mat = selected?.metadataAvatarType;
        if (mat) return typeof mat === 'string' ? mat : mat.id || mat['@id'];
        return selected?.metadataAvatarTypeId;
    })();

    // Usa el campo plano (boards) si viene informado; si no, el componente async
    // que resuelve la propiedad por metadataAvatarType (avatares).
    const specValue = (flat: any, propName: string): React.ReactNode => {
        if (flat !== undefined && flat !== null && flat !== '') return flat;
        return metadataId ? (
            <MetadataAvatarTypePropertiesBatched metadataAvatarType={metadataId} name={propName} />
        ) : (
            '-'
        );
    };

    return (
        <CollapsePanel icon={<CategoryIcon fontSize='small' />} title={'Caractéristiques'}>
            <Box style={{ display: 'grid', gap: 8 }}>
                <InfoItem
                    label={t('app.ancs.sludgeStorageVolume')}
                    value={specValue(selected?.sludgeStorageVolume, 'sludgeStorageVolume')}
                />
                <InfoItem
                    label={'Volume totale utile'}
                    value={specValue(selected?.totalUsefulVolume, 'totalUsefulVolume')}
                />
                <InfoItem label={'Modèle'} value={specValue(selected?.model, 'model')} />
                <InfoItem
                    label={'Capacité de traitement'}
                    value={specValue(selected?.processingCapacity, 'processingCapacity')}
                />
            </Box>
        </CollapsePanel>
    );
};

export default CharacteristicsPanel;
